import React from 'react';
import PropTypes from 'prop-types';

import { Menu } from 'lucide-react';
import NavMenu from './nav/NavMenu';
import Search from './nav/Search';

import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const Nav = ({ handleDrawerToggle, isCollapsed }) => {
  return (
    <header
      className={cn(
        'tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-z-30 tw-h-[80px] tw-flex tw-justify-between tw-items-center tw-px-8 tw-transition-all tw-duration-300',
        'tw-bg-gray-50/80 tw-backdrop-blur-md',
        isCollapsed ? 'sm:tw-left-20' : 'sm:tw-left-64'
      )}
    >
      <button
        onClick={handleDrawerToggle}
        className="tw-text-gray-400 tw-p-2 hover:tw-bg-gray-50 tw-rounded-xl tw-transition-colors"
        aria-label="open drawer"
      >
        <Menu className="tw-h-6 tw-w-6" />
      </button>
      <div className="tw-flex tw-items-center tw-space-x-4 sm:tw-space-x-6">
        <Search />
        <NavMenu />
      </div>
    </header>
  );
};

export default Nav;

Nav.propTypes = {
  handleDrawerToggle: PropTypes.func,
  isCollapsed: PropTypes.bool
};
